import axios from "axios";

// Resolve the API base URL.
//
// Normally we use REACT_APP_BACKEND_URL (baked in at build time). However, when
// the production app is reached via a *custom domain* that was connected after
// the build, the baked-in URL points at the platform host (e.g.
// "https://blockchain-ballot-10.emergent.host") while the user is sitting on
// "https://customer-domain.com". That's a cross-origin call which sometimes
// trips CORS / cookie / mixed-host rules silently and makes public endpoints
// like /api/elections come back empty.
//
// To make the frontend resilient: if the page is being served from a different
// host than the baked-in backend URL, fall back to same-origin (browser will
// hit `<current host>/api/...` and Emergent's ingress routes those to the
// backend regardless of which domain is in the URL bar).
const RAW_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

function resolveBackendUrl() {
    if (typeof window === "undefined") return RAW_BACKEND_URL;
    if (!RAW_BACKEND_URL) return window.location.origin;
    try {
        const configured = new URL(RAW_BACKEND_URL);
        if (configured.host !== window.location.host) {
            return window.location.origin;
        }
        return RAW_BACKEND_URL;
    } catch {
        return window.location.origin;
    }
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const tok = localStorage.getItem("cc_token");
    if (tok) config.headers.Authorization = `Bearer ${tok}`;
    return config;
});

export default api;

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
